module.exports = __webpack_public_path__ + "static/media/admin-left.e237e352.jpg";